// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"19e5e6bd","251":"36cc2688","348":"49c83194","364":"108a929c","571":"c1e57cbf"}[chunkId] + ".chunk.js";
};